import React from "react";
import Styles from "./index.module.scss";
import { Modal, Typography } from "antd";
import { useToggle } from "react-use";

const { Title, Paragraph, Text } = Typography;

const Index = () => {
    const [visible, toggleVisible] = useToggle(false);
    return (
        <div className={Styles.root}>
            <div onClick={toggleVisible} className={Styles.how}>
                如何计算成绩？
            </div>

            <Modal
                width={1000}
                visible={visible}
                onCancel={toggleVisible}
                footer={null}>
                <div style={{ padding: 15 }}>
                    <div className={Styles.box}>
                        <Typography>
                            <div className={Styles.title}>
                                按率计算得分的规则是什么？
                            </div>
                            <div className={Styles.cont}>
                                a）参与率=参与互动次数/发布互动总次数 *100%{" "}
                                <br />
                                b）若设置高级设置，则根据设置的分数段得到对应互动得分。
                                <br />
                                若未设置高级设置，则参与率*100即为互动得分{" "}
                                <br />
                                c）考核模块得分=互动得分*考核模块权重
                            </div>
                            <div className={Styles.title}>
                                【示例】教师总共发布8次投票，学生A参加6次，按参与率计算成绩，并设置高级设置
                                70% &lt;= 参与率 &lt;80%
                                得70分。投票权重为5%，则：
                            </div>
                            <div className={Styles.conts}>
                                a）参与率=6/8*100%=75% <br />
                                b）按高级设置，互动得分为70分 <br />
                                c）学生A投票模块得分=70*5%=3.5分
                            </div>
                            <div className={Styles.title}>
                                按次计算得分的规则是什么？
                            </div>
                            <div className={Styles.cont}>
                                a）按照参与数据获得参与次数 <br />
                                b）若设置高级设置，则根据设置的分数段得到对应互动得分。
                                <br />
                                若未设置高级设置，则参与率*100即为互动得分
                                <br />
                                c）考核模块得分=互动得分*考核模块权重
                            </div>
                            <div className={Styles.title}>
                                【示例】教师总共发布8次练习，学生B参加6次，按参与次数计算成绩，未设置高级设置
                                。练习权重为10%，则：
                            </div>
                            <div className={Styles.conts}>
                                a）参与次数6次 <br />
                                b）未设高级设置，按参与率计算互动得分为75分{" "}
                                <br />
                                c）学生B练习模块得分=75*10%=7.5分
                            </div>
                            <div className={Styles.title}>
                                按平均分计算得分的规则是什么？
                            </div>
                            <div className={Styles.cont}>
                                未设置明细分配时： <br />
                                a）单次互动百分制得分=互动卷面得分/本次互动满分
                                *100
                                <br />
                                b）平均分=全部单次互动百分制加和/互动次数 <br />
                                c）若设置高级设置，则根据设置的分数段得到对应互动得分。
                                <br />
                                若未设置高级设置，则平均分即为互动得分 <br />
                                d）考核模块得分=互动得分*考核模块权重 <br />
                                设置明细分配时： <br />
                                a）单次互动百分制得分=互动卷面得分/本次互动满分
                                *100
                                <br />
                                b）全部互动得分=明细分配中各项权重*对应的单次互动得分后求和
                                <br />
                                c）若设置高级设置，则根据设置的分数段得到对应互动得分。
                                <br />
                                若未设置高级设置，则全部互动得分即为互动得分{" "}
                                <br />
                                d）考核模块得分=互动得分*考核模块权重
                            </div>
                            <div className={Styles.title}>
                                【示例】教师共发布3次作业，学生C得分分别为
                                80分、18（20满分）、70分，
                                作业模块权重20%，未设置高级设置，则
                            </div>
                            <div className={Styles.conts}>
                                未设置明细分配时： <br />
                                a）单次百分制成绩为：80分、18/20*100=90分、70分
                                <br />
                                b）平均分=（80+90+70）/3=80分 <br />
                                c）未设置高级设置，互动得分为80分 <br />
                                d）学生C作业得分=80*20%=16分 <br />
                                设置明细分配时：三次作业权重分别为20%，30%，50%，则
                                <br />
                                b）全部互动的得分=80*20%+90*30%+70*50%=78分{" "}
                                <br />
                                c）未设置高级设置，互动得分为78分 <br />
                                d）学生C作业得分=78*20%=15.6分
                            </div>
                        </Typography>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Index;
